import { render, staticRenderFns } from "./ManterComarcaEditar.vue?vue&type=template&id=0a235356&scoped=true&"
import script from "./ManterComarcaEditar.vue?vue&type=script&lang=js&"
export * from "./ManterComarcaEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a235356",
  null
  
)

export default component.exports